module.exports = __webpack_public_path__ + "static/media/207.ed55387e.jpg";